import { Check, Lock, RefreshCw } from 'lucide-react'
import type { ReactNode } from 'react'

/** Inline trust strip — three short reassurances rendered side-by-side. */
export function OutreachTrustRow() {
  return (
    <section className="mb-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
      <TrustInline
        icon={<Check className="size-3.5" strokeWidth={3} />}
        text="Every campaign human-reviewed before launch."
      />
      <TrustInline
        icon={<Lock className="size-3.5" strokeWidth={3} />}
        text="Tracking only conversations we initiate, never your existing inbox."
      />
      <TrustInline
        icon={<RefreshCw className="size-3.5" strokeWidth={3} />}
        text="Pause or refund in one click."
      />
    </section>
  )
}

function TrustInline({ icon, text }: { icon: ReactNode; text: string }) {
  return (
    <div className="inline-flex items-center gap-2 text-[12.5px] text-foreground/85">
      <span className="text-primary">{icon}</span>
      <span>{text}</span>
    </div>
  )
}
